import IdiomGameLogs from '../views/idiomgame/logs.vue'
export default [
  {
    path: '/idiomgame/logs',
    name: "idiomgame.logs",
    component: IdiomGameLogs
  }
]